import React, { useState, useEffect, useContext } from 'react';
import { Link, useParams, useNavigate } from "react-router-dom";
import { InputContext } from '../../contexts/InputContext';
import MessageModal from '../../container/MessageModal';
import TextControl from '../../container/customizedInputs/TextControl';
import { errorClassification } from '../../errorHandler';

import cargosServices from '../../services/cargosServices';

const CargoForm = () => {
  const navigate = useNavigate();
  const [authInformation, setAuthInformation] = useContext(InputContext)
  const [cargo, setCargo] = useState({});
  const [esNuevo, setEsNuevo] = useState(true);
  const [renderHTML, setRenderHTML] = useState(false);

  // modal messages
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState('');
  const handleShowModal = (message) => {setModalBody(message); setShowModal(true)};
  const handleCloseModal = () => { setShowModal(false); setModalBody('') };

  let { id } = useParams();

  useEffect(() => {
    setEsNuevo( id === undefined )

    if(id){
      fetchCargo(id)
    } else {
      nuevaCargo()
    }
  }, [id]);

  useEffect(() => {
    if(authInformation.autenticado === false){
      navigate(`/ingreso`);
    } else if(authInformation.autenticado === true && authInformation.rol === 'Admin'){
      setRenderHTML(true)
    } else if( (authInformation.autenticado === true) && (authInformation.rol !== 'Admin')){
      navigate(`/`);
    } else {
      setRenderHTML(false)
    }
  }, [authInformation]);

  const fetchCargo = async (id) => {
    try {
      const data = await cargosServices.obtenerCargoPorId(id);
      setCargo(data);
    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };


  const nuevaCargo = async () => {
    try {
      setCargo({nombre: '', categoria: '', agrupamiento: ''});
    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const guardarCargo = async () => {
    try {
      let data;
      if(esNuevo){
        data = await cargosServices.crearCargo({cargo: cargo});
      } else {
        data = await cargosServices.actualizarCargo(cargo.id, {cargo: cargo});
      }

      setCargo(data);

      handleShowModal("Datos actualizados")
      if(esNuevo){
        navigate(`/cargo/${data.id}/edit`);
      }

    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setCargo({...cargo,
        [name]: value
    })
  }

  const handleFormSubmit = (e) => {
    e.preventDefault()

    guardarCargo()
  }

  return (
    <>
      {
        renderHTML  && (
          <main className="w-100 m-auto" style={{maxWidth: '660px'}}>
            <form>
              <TextControl
                className='mb-3'
                value={cargo.nombre}
                name={'nombre'}
                handleInput={handleInput}
              />

              <TextControl
                className='mb-3'
                value={cargo.categoria}
                name={'categoria'}
                label={'Categoría'}
                handleInput={handleInput}
              />

              <TextControl
                className='mb-3'
                value={cargo.agrupamiento}
                name={'agrupamiento'}
                handleInput={handleInput}
              />


              <div className="d-grid gap-2 d-sm-flex justify-content-sm-center">
                <button className="btn btn-primary w-100 py-2" onClick={handleFormSubmit} type="submit">Guardar</button>
                <button className="btn btn-outline-secondary px-4" type='button' onClick={() => navigate(-1)}>Volver</button>
              </div>
            </form>
          </main>
        )
      }

     <MessageModal
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        modalBody={modalBody}
     />
    </>
  );
};

export default CargoForm;